// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"180":"App","214":"views-error","475":"views"}[chunkId] || chunkId) + "." + {"180":"b46c286f","214":"bb724d9c","455":"d1304e8a","475":"e83fab21","826":"d17718d1","837":"d908c7f0","893":"e192883c"}[chunkId] + ".chunk.js";
};